<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="设备名称" prop="name">
        <el-input v-model="form.name" minlength="1" maxlength="20" placeholder="请输入设备名称"></el-input>
      </el-form-item>
      <el-form-item label="设备编码" prop="deviceCode">
        <el-input v-model="form.deviceCode" minlength="1" maxlength="12" placeholder="请输入设备编码" :disabled="handleType === 'edit'"></el-input>
      </el-form-item>
      <el-form-item label="设备类型" prop="deviceType">
        <el-select v-model="form.deviceType" placeholder="请选择设备类型" :disabled="handleType === 'edit'">
          <el-option v-for="item in deviceList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装区域" prop="zone">
        <el-select v-model="form.zone" placeholder="请选择安装区域">
          <el-option v-for="item in zoneList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装位置" prop="location">
        <el-input v-model="form.location" minlength="1" maxlength="20" placeholder="请输入安装位置"></el-input>
      </el-form-item>
      <el-form-item label="关联摄像" prop="camera">
        <el-select v-model="form.cameraId" clearable placeholder="请选择摄像头">
          <el-option v-for="item in cameraList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注信息" prop="remarks">
        <el-input type="textarea" v-model="form.remarks" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      left: "left",
      show: "添加",
      // loading: false,
      cameraList: [],
      zoneList: [],
      deviceList: [],
      form: {
        name: '',
        deviceCode: '',
        location:'',
        remarks: '',
        deviceType: '',
        zone: '',
        cameraId: '',
      },
      formRules: {
        name: [
          {
            required: true,
            validator: this.validateDeviceName,
            trigger: "blur"
          }
        ],
        deviceCode: [{
          required: true,
          validator: this.validateDeviceCode,
          trigger: "blur"
        }],
        location: [{
          required: true,
          validator: this.validateLocation,
          trigger: "blur"
        }],
        deviceType:[{
         required: true,
          message: "请选择设备类型",
          trigger: ["change"] 
        }],
        zone:[{
          required: true,
          message: "请选择安装区域",
          trigger: ["blur"] 
        }]
      },
    }
  },
  created() {
    console.log(this.handleType)
    console.log(this.editData)
  },
  mounted() {
    this.init();
  },
  inject:['pinit','pinitdata'],
  methods: {
    init() {
      this.request.get("/Zone/queryAll").then(res => { //区域管理
        console.log(res)
        if (res.code == 200) {
          this.zoneList = res.data;
         //  this.form.zone=this.zoneList[0].id;
        } else if(res.code==500){
          this.msg.warn(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
      this.request.get("/deviceType/findAll").then(res => { //设备类型
        console.log(res)
        if (res.code == 200) {
          this.deviceList = res.data;
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error)
      })
      this.request.get("/camera/findAll").then(res => { //摄像头
        console.log(res)
        if (res.code == 200) {
          this.cameraList = res.data;
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error)
      })
      if (this.handleType == 'add') {
      //   this.form.name = null
      //   this.form.deviceCode = null
      //   this.form.deviceType = null
      //   this.form.zone = null
      //   this.form.location = null
      //   this.form.cameraId = null
      //   this.form.remarks = null
      } else if (this.handleType == 'edit') {
        console.log(this.editData)
        if (this.editData.id) {
          this.form = {
            name: this.editData.name,
            deviceCode: this.editData.deviceCode,
            location: this.editData.location,
            remarks: this.editData.remarks,
            deviceType: parseInt(this.editData.devtypeid),
            zone: this.editData.zoneId,
            cameraId: this.editData.cameraId,
          }
          console.log(this.form);

        }
      }
    },
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      //确认
      // console.log(this.handleType);
      // console.log(this.form.date1);
      // console.log(this.value1);
      let formDates = {
        name: this.form.name,
        deviceCode: this.form.deviceCode,
        devtypeid: this.form.deviceType,
        zoneId: this.form.zone,
        location: this.form.location,
        cameraId: this.form.cameraId,
        remarks:this.form.remarks
      };
      console.log(formDates);
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.$emit("update:loading", true);
        if (this.handleType == 'add') {
          this.request.post("/deviceinstall/add", formDates).then(res => {
            this.$emit("update:loading", false);
            console.log(res);
            if (res.code == 200) {
              this.msg.success('设备添加成功');
              this.$emit('confirm', res.code);
              this.pinit();
              this.pinitdata();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        } else if (this.handleType == 'edit') {
          let source = {
            id: this.editData.id,
            // termid: this.getEditData.termid
          }
          let editDatas = Object.assign(formDates, source);
          console.log(editDatas)
          this.request.put("/deviceinstall/edit", editDatas).then(res => {
            console.log(res);
            this.$emit("update:loading", false);
            if (res.code == 200) {
              this.msg.success('设备编辑成功')
              this.$emit('confirm', res.code)
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        }
        // this.$emit("confirm", this.form);
        //   this.storage.setSession("headImg", this.form.img);
      });
    },
    validateDeviceName(rule, value, callback) {
      if (value === ""||value === null) {
        callback(new Error("设备名不能为空"));
      } else if (value.length > 20) {
        callback(new Error("设备名长度不能超过20个字符"));
      } else if (value.length < 1) {
        callback(new Error("设备名长度不能少于1个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("设备名不合法,请输入由_或字母或汉字或数字组成！")
          );
        } else {
          callback();
        }
      }
    },
    validateDeviceCode(rule, value, callback) {
      if (value === ""||value === null) {
        callback(new Error("编码不能为空"));
      } else if (value.length > 12) {
        callback(new Error("编码长度必须为12个字符"));
      } else if (value.length < 12) {
        callback(new Error("编码长度必须为12个字符"));
      } else {
        var reg = new RegExp(/^[0-9a-zA-Z]*$/);
        if (!reg.test(value)) {
          callback(new Error("编码不合法,请输入由英文(a-z/A-Z)或数字组成的编码！"));
        } else {
          callback();
        }
      }
    },
    validateLocation(rule, value, callback) {
      if (value === ""||value === null) {
        callback(new Error("安装位置不能为空"));
      } else if (value.length > 20) {
        callback(new Error("安装位置长度不能超过20个字符"));
      } else if (value.length < 1) {
        callback(new Error("安装位置长度不能少于1个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("安装位置不合法,请输入由_或字母或汉字或数字组成！")
          );
        } else {
          callback();
        }
      }
    },
  }
};
</script>

<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
